// extracted by mini-css-extract-plugin
export default {"content":"BoardView_content__YDQ6J","lists":"BoardView_lists__0hA1e","list":"BoardView_list__Ti9SP"};